import { takeLatest, put, select } from 'redux-saga/effects';
import { createAxios } from '../utils/utils';
import { WELCOME_DATA_65, WELCOME_POPUP_STATUS_URL } from '../config/index';

import {
  GET_WELCOME_DATA,
  SET_WELCOME_DATA,
  SET_RECENT_POPUP_STRATEGY,
} from '../constants/Welcome';

function* fetchGetWelcomData({ payload }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.post(WELCOME_DATA_65, payload);
    if (res.data.status === 0) {
      yield put({
        type: SET_WELCOME_DATA,
        payload: res.data.data,
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchFetchGetWelcomData() {
  yield takeLatest(GET_WELCOME_DATA, fetchGetWelcomData);
}

function* fetchRecentPopupStrategy({ payload }) {
  try {
    const axios = yield createAxios();
    yield axios.post(WELCOME_POPUP_STATUS_URL, payload);
  } catch (error) {
    // throw error;
  }
}
export function* watchFetchRecentPopupStrategy() {
  yield takeLatest(SET_RECENT_POPUP_STRATEGY, fetchRecentPopupStrategy);
}
